export default "__VITE_ASSET__CWHnKt6V__"